// Library Methods
import { createContext, useState, useContext } from "react";

// Types
import { SnackbarInfoType } from "src/components/shared/alerts/SnackbarMessage/SnackbarMessage";

const SnackbarContext = createContext({
  snackbarInfo: undefined as SnackbarInfoType | undefined,
  setSnackbarInfo: (_: any) => {},
});

export const useSnackbarContext = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error(
      "useSnackbarContext must be used within SnackbarContextProvider"
    );
  }

  return context;
};

type SnackbarProviderType = {
  children: React.ReactNode;
};

const SnackbarProvider = ({ children }: SnackbarProviderType) => {
  const [snackbarInfo, setSnackbarInfo] = useState<
    SnackbarInfoType | undefined
  >();

  return (
    <SnackbarContext.Provider
      value={{
        snackbarInfo,
        setSnackbarInfo,
      }}
    >
      {children}
    </SnackbarContext.Provider>
  );
};

export default SnackbarProvider;
